import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bookService: {
    description: '',
    code: '',
    expression: '',
    type: '',
    isRequiredContainer: false,
  },
};

export const createBookService = createSlice({
  name: 'createBookService',
  initialState,
  reducers: {
    updateBookServiceInfo: (state, action) => {
      state.bookService = action.payload;
    },
    updateBookServiceInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.bookService[field] = value;
    },
    clearBookServiceInfo: (state) => {
      state.bookService = initialState.bookService;
    },
  },
});

export const bookServiceDetailSelector = (state) =>
  state.createBookService.bookService;
export const {
  updateBookServiceInfo,
  updateBookServiceInfoField,
  clearBookServiceInfo,
} = createBookService.actions;

export const createBookServiceReducer = createBookService.reducer;
export const createBookServiceReducerName = createBookService.name;

export default createBookService.reducer;
